export const PLAQUE_FIELDS = [
  ["make", "Make"], ["model", "Model"], ["generation", "Generation"], ["year", "Year"],
  ["trim", "Trim / Variant"], ["engine", "Engine"], ["power", "Power"], ["torque", "Torque"],
  ["transmission", "Transmission"], ["weight", "Curb Weight"], ["color", "Exterior Color"],
  ["buildId", "Build ID"], ["ownerName", "Owner name"], ["customLine", "Custom line"],
];
export const PLAQUE_DEFAULTS = {
  schemaVersion: 1, templateId: "brushed-metal", templateVersion: 1,
  visibleFields: PLAQUE_FIELDS.map(([key]) => key).filter((key) => !["ownerName", "customLine"].includes(key)),
  artworkId: null, artworkVersion: null, vinMode: "hidden", specificationSource: "current",
  appearance: { density: "comfortable" }, ownerName: "", customLine: "", revision: 0,
};

export function plaqueVin(vin, mode, isOwner) {
  if (!isOwner || !vin || mode === "hidden") return "";
  if (mode === "last6") return vin.slice(-6);
  return mode === "full" ? vin : "";
}

export function vehicleToPlaque(car = {}, config = PLAQUE_DEFAULTS) {
  const stages = Array.isArray(car.stages) ? car.stages : [];
  const current = stages.find((stage) => stage.id === car.currentStageId) ||
    stages.find((stage) => stage.isCurrent) || stages[0];
  const source = config.specificationSource || "current";
  const clean = (value) => typeof value === "string" ? value.trim() :
    typeof value === "number" && Number.isFinite(value) ? String(value) : "";
  const first = (...values) => values.map(clean).find((value) => value !== "") || "";
  // Legacy specs represent the current build only when there is no stage.
  // OEM mode never borrows modified stage/legacy specifications.
  const base = car.oemSpecs || {};
  const build = current ? current.specs || {} : car.specs || {};
  const spec = (key) => source === "legacy" ? first(car.specs?.[key]) :
    source === "oem" ? first(base[key], car[key]) : first(build[key], base[key], car[key]);
  const values = {
    make: car.make, model: car.model, year: car.year,
    generation: first(car.generationLabel, car.generation, car.generationId),
    trim: first(car.trim, car.variantLabel, car.variant, car.variantId),
    color: first(car.color, car.exteriorColor), buildId: car.buildId,
    engine: spec("engine"), power: spec("power"), torque: spec("torque"),
    transmission: spec("transmission"), weight: spec("weight"),
    ownerName: config.ownerName, customLine: config.customLine,
  };
  return { source, values: Object.fromEntries(Object.entries(values).map(([key, value]) => [key, clean(value)])) };
}
